<template id="report">
  <div>
    <ReportItem label="5,00€" :item="report.report5" vvFormScope="report010"></ReportItem>
    <ReportItem label="10,00€" :item="report.report10" vvFormScope="report020"></ReportItem>
    <ReportItem label="20,00€" :item="report.report20" vvFormScope="report050"></ReportItem>
    <ReportItem label="50,00€" :item="report.report50" vvFormScope="report1"></ReportItem>
                                     <h4>Obračun - bankovci: {{((report.report5.amount*report.report5.value)+
                             (report.report10.amount*report.report10.value)+
                             (report.report20.amount*report.report20.value)+
                             (report.report50.amount*report.report50.value)).toFixed(2) + "€"}}</h4>
                             <vs-divider></vs-divider>
        <h4 class="mt-base">Obračun - skupaj: {{((report.report010.amount*report.report010.value)+
                             (report.report020.amount*report.report020.value)+
                             (report.report050.amount*report.report050.value)+
                             (report.report1.amount*report.report1.value)+
                             (report.report2.amount*report.report2.value)+
                             (report.report5.amount*report.report5.value)+
                             (report.report10.amount*report.report10.value)+
                             (report.report20.amount*report.report20.value)+
                             (report.report50.amount*report.report50.value)).toFixed(2) + "€"}}</h4>
</div>
</template>
<script>
import ReportItem from './ReportTemplate1Item.vue'
export default {
  inject: ["$validator"],
  name: "report-component",
  template: "#report",
  props: {
    report: {
      type: Object
    },
    vvFormScope: {
      type: String
    }
  },
  filters: {
    ToUppercase: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    }
  },
  components: {
      ReportItem
  }
};
</script>